import React, { useState } from 'react';
import { Code } from 'lucide-react';
import type { WidgetStrings } from '../../utils/i18n';
import { DEFAULT_WIDGET_STRINGS } from '../../utils/i18n';

interface ThinkingDisplayProps {
  thinking: string;
  strings?: WidgetStrings;
}

const ThinkingDisplay = React.memo(function ThinkingDisplay({
  thinking,
  strings = DEFAULT_WIDGET_STRINGS,
}: ThinkingDisplayProps) {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="mt-3 bg-purple-50 border border-purple-200 rounded-lg p-2">
      <button
        onClick={() => setExpanded(!expanded)}
        type="button"
        className="flex items-center gap-2 text-xs text-purple-900 font-semibold w-full focus:outline-2 focus:outline-blue-500"
        aria-expanded={expanded}
        aria-label={expanded ? strings.collapseReasoning : strings.expandReasoning}
      >
        <Code className="w-3 h-3" />
        <span>{strings.agentReasoning}</span>
        <span className="ml-auto">{expanded ? '\u2212' : '+'}</span>
      </button>
      {expanded && (
        <div className="mt-2 text-xs text-purple-800 whitespace-pre-wrap">{thinking}</div>
      )}
    </div>
  );
});

export default ThinkingDisplay;
